import Vue from 'vue';
import permitCardCounterService from '@/api/permit-card-counter-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

export const getDefaultPermitCardCounterFilterParams = () => ({});

const state = {
  permitCardCounters: null,
  newPermitCardCounters: {},
  permitCardCounterValidationErrors: {},
  permitCardCounterFilterParams: getDefaultPermitCardCounterFilterParams(),
};

const getters = {};

const mutations = {
  SET_PERMIT_CARD_COUNTERS(state, data) {
    state.permitCardCounters = data;
  },

  SET_NEW_PERMIT_CARD_COUNTERS(state, counters) {
    state.newPermitCardCounters = counters;
  },

  UPDATE_PERMIT_CARD_COUNTER(state, counter) {
    state.permitCardCounters = counter;
  },

  SET_PERMIT_CARD_COUNTER_FILTER_PARAMS(state, params) {
    state.permitCardCounterFilterParams = params;
  },

  SET_PERMIT_CARD_COUNTER_VALIDATION_ERRORS(state, permitCardCounterValidationErrors) {
    state.permitCardCounterValidationErrors = permitCardCounterValidationErrors;
  },

  CLEAR_PERMIT_CARD_COUNTER_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.permitCardCounterValidationErrors, field);
  },
};

const actions = {
  fetchPermitCardCounters({ commit }, params) {
    commit('SET_PERMIT_CARD_COUNTER_FILTER_PARAMS', params);
    return permitCardCounterService.getCardCounters(params).then((res) => {
      commit('SET_PERMIT_CARD_COUNTERS', res.data[0]);
      if (params.page !== state.permitCardCounterFilterParams.page) {
        window.scrollTo(0, 0);
      }
      return res.data;
    });
  },

  updatePermitCardCounter({ commit }, permitCardCounter) {
    return permitCardCounterService
      .update(permitCardCounter)
      .then((res) => {
        commit('SET_NEW_PERMIT_CARD_COUNTERS', {});
        commit('UPDATE_PERMIT_CARD_COUNTER', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('permit_card_counter_updated'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_PERMIT_CARD_COUNTER_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearPermitCardCounterValidationErrors({ commit }, field) {
    commit('CLEAR_PERMIT_CARD_COUNTER_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
